import * as types from '../constants/types';

const setVisitedSubunitsAction =
  ({ subjectId, userId, unitNumber, number, isVisited }) =>
  (dispatch) => {
    dispatch({
      type: types.SET_VISITED_SUBUNITS,
      payload: {
        subjectId,
        userId,
        unitNumber,
        number,
        isVisited,
      },
    });
  };

const setAllVisitedSubunitsAction =
  ({ subjectId, userId, unitNumber, visitedSubunits }) =>
  (dispatch) => {
    dispatch({
      type: types.UPDATE_ALL_VISITED_SUBUNITS,
      payload: {
        subjectId,
        userId,
        unitNumber,
        visitedSubunits,
      },
    });
  };

export { setVisitedSubunitsAction, setAllVisitedSubunitsAction };
